import type { MediaCarouselProps } from '@/components/BlackFriday/MediaWithCarousel/types'

const FREE_DOCUMENT_CONSULTING = {
  title: 'Consulta gratuita de CPF e CNPJ de terceiros',
  subtitle: 'Faça até 2 consultas* ao CPF e CNPJ de terceiros para ver pendências financeiras.',
  image: {
    url: 'https://cdn.builder.io/api/v1/image/assets%2Fb212bb18f00a40869a6cd42f77cbeefc%2Fbc04b787999f4ffe9d97ce96a0e180a4',
    alt: 'Juiz segurando cartão ',
  },
  position: 'right' as const,
  sectionPurpose: 'freeDocumentConsulting' as const,
}

const LINK_INTEGRITY_CHECK = {
  title: 'Verificador de Site Suspeito',
  subtitle:
    'Vai comprar online? Cole o link do site aqui para saber se ele é seguro antes de fechar sua compra.',
  image: {
    url: 'https://cdn.builder.io/api/v1/image/assets%2Fb212bb18f00a40869a6cd42f77cbeefc%2Fefd1e42cbb9943759e64519a373844e0',
    alt: 'Juiz puxando cartão do bolso ',
  },
  position: 'left' as const,
  sectionPurpose: 'linkIntegrityCheck' as const,
}

const CAROUSEL_VIDEOS: MediaCarouselProps = {
  title: 'Playlist Central da Black ',
  cta: {
    label: 'Quero me proteger',
    href: 'https://www.serasa.com.br/premium/checkout/PREMIUM_ANUAL?cupom=BLACKFRIDAY2022',
    ariaLabel: 'Quero me proteger comprando o Premium com 30% de desconto, link externo',
  },
  items: [
    {
      type: 'video',
      title: 'Como passar a black sem fraude',
      ariaLabel: 'Como passar a black sem fraude',
      video: { url: 'https://www.youtube.com/watch?v=5gmYq-0Hrek' },
      image: {
        url: 'https://cdn.builder.io/api/v1/image/assets%2Fb212bb18f00a40869a6cd42f77cbeefc%2F635ca932be5c47cfba292ab958b532e1',
      },
    },
    {
      type: 'video',
      title: 'melhores cartoes de credito para usar na black friday',
      ariaLabel: 'melhores cartoes de credito para usar na black friday',
      video: { url: 'https://www.youtube.com/watch?v=MQDYGquiwXw' },
      image: {
        url: 'https://cdn.builder.io/api/v1/image/assets%2Fb212bb18f00a40869a6cd42f77cbeefc%2Feebdaa4b56244346bfda83612a9f0957',
      },
    },
    {
      type: 'video',
      title: 'como economizar ainda mais na black friday',
      ariaLabel: 'como economizar ainda mais na black friday',
      video: { url: 'https://www.youtube.com/watch?v=b3EOlFveFYA' },
      image: {
        url: 'https://cdn.builder.io/api/v1/image/assets%2Fb212bb18f00a40869a6cd42f77cbeefc%2F36b5113dad064ac494174dad4060dd91',
      },
    },
    {
      type: 'video',
      title: 'tipos de golpes da black friday',
      ariaLabel: 'tipos de golpes da black friday',
      video: { url: 'https://www.youtube.com/watch?v=R-NaKjWGVD4' },
      image: {
        url: 'https://cdn.builder.io/api/v1/image/assets%2Fb212bb18f00a40869a6cd42f77cbeefc%2F32c0eca819f94af898df73778d453c38',
      },
    },
    {
      type: 'video',
      title: 'Como fazer uma compra online segura na black friday',
      ariaLabel: 'Como fazer uma compra online segura na black friday',
      video: { url: 'https://www.youtube.com/watch?v=GXqEG0oFsSg' },
      image: {
        url: 'https://cdn.builder.io/api/v1/image/assets%2Fb212bb18f00a40869a6cd42f77cbeefc%2Fed45a11196f641f183ce43978208d7d5',
      },
    },
  ],
}

const CAROUSEL_BLOG_POSTS: MediaCarouselProps = {
  title: 'Saiba como evitar golpes na Black Friday ',
  cta: {
    label: 'Assine o Premium Anual 30% OFF',
    href: 'https://www.serasa.com.br/premium/checkout/PREMIUM_ANUAL?cupom=BLACKFRIDAY2022',
    ariaLabel: 'Quero me proteger comprando o Premium com 30% de desconto, link externo',
  },
  items: [
    {
      href: 'https://www.serasa.com.br/premium/blog/black-friday-dicas-para-nao-cair-em-golpes-nessa-epoca-do-ano/',
      type: 'image',
      title: 'não caia em golpes nessa black',
      ariaLabel: 'não caia em golpes nessa black, link externo',
      image: {
        url: 'https://cdn.builder.io/api/v1/image/assets%2Fb212bb18f00a40869a6cd42f77cbeefc%2F66214a75f461499fb22c2e326c71d368',
      },
    },
    {
      type: 'image',
      href: 'https://www.serasa.com.br/premium/blog/black-fraude-conheca-os-golpes-mais-comuns/',
      title: 'golpes mais comuns na black friday',
      ariaLabel: 'golpes mais comuns na black friday , link externo',
      image: {
        url: 'https://cdn.builder.io/api/v1/image/assets%2Fb212bb18f00a40869a6cd42f77cbeefc%2Fe66f5dc2e1704cb89b6d4936507e276c',
      },
    },
    {
      type: 'image',
      href: 'https://www.serasa.com.br/premium/blog/black-friday-como-comparar-precos/',
      title: 'como saber qual o melhor desconto',
      ariaLabel: 'como saber qual o melhor desconto, link externo',
      image: {
        url: 'https://cdn.builder.io/api/v1/image/assets%2Fb212bb18f00a40869a6cd42f77cbeefc%2F15dc5880609845679e6c6d3f2caed597',
      },
    },
    {
      type: 'image',
      href: 'https://www.serasa.com.br/premium/blog/black-friday-serasa/',
      title: 'proteja seus dados na black fraude',
      ariaLabel: 'proteja seus dados na "black fraude", link externo',
      image: {
        url: 'https://cdn.builder.io/api/v1/image/assets%2Fb212bb18f00a40869a6cd42f77cbeefc%2Fe4a207c085cc481b9ec91439b9e43ea4',
      },
    },

    {
      type: 'image',
      href: 'https://www.serasa.com.br/premium/blog/black-friday-oito-sites-para-monitorar-precos-e-fraudes/',
      title: 'Monitore preços e fraudes',
      ariaLabel: 'Monitore preços e fraudes, link externo',
      image: {
        url: 'https://cdn.builder.io/api/v1/image/assets%2Fb212bb18f00a40869a6cd42f77cbeefc%2Fc1bedbbf460d42dd88864c4e898f7e0a',
      },
    },
  ],
}

export const MEDIA_WITH_CAROUSEL = {
  CAROUSEL_VIDEOS,
  CAROUSEL_BLOG_POSTS,
}

export const MEDIA_WITH_FORMS = {
  FREE_DOCUMENT_CONSULTING,
  LINK_INTEGRITY_CHECK,
}
